module.exports = __webpack_public_path__ + "static/media/logout-vector.edb76c97.svg";